export const base = '/wizard';

export const routes = {
  base,
  campaign: `${base}/:campaignId?/:sectionId?/:paneId?`,
  quickstart: `${base}/quickstart/:campaignId?/:sectionId?/:paneId?`,
} as const;
